<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <i class="icon-bell"></i><b-badge pill variant="danger">{{itemsCount + notificacoesAvaliacao.length}}</b-badge>
    </template>
    <template slot="dropdown">
      <ul tabindex="-1" aria-labelledby="__BVID__91__BV_button_" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-150px, -5px, 0px);" class="dropdown-menu pt-0 show">
            <div class="dropdown-menu pt-0 show">
                <div class="dropdown-header bg-light">
                    <strong>Você tem {{itemsCount + notificacoesAvaliacao.length}} Notificações </strong>
                </div>
                <li role="presentation" v-if="gestorPendente" @click="redirectGestor">
                    <a role="menuitem" target="_self" href="#" class="dropdown-item"><i class="icon-user-follow text-warning"></i>
                        <small class="text-muted">{{gestorPendente}} Gestor (es) Pendentes de Ativação</small>
                    </a>
                </li>
                <li role="presentation" v-if="tutorPendente" @click="redirectTutorInstrutor">
                    <a role="menuitem" target="_self" href="#" class="dropdown-item"><i class="icon-user-follow text-danger"></i>
                        <small class="text-muted">{{tutorPendente}} Tutor (es) Pendentes de Ativação</small>
                    </a>
                </li>
                <li role="presentation" v-if="beneficiarioPendente" @click="redirectBeneficiario">
                    <a role="menuitem" target="_self" href="#" class="dropdown-item"><i class="icon-user-follow text-success"></i>
                        <small class="text-muted">{{beneficiarioPendente}} Beneficiário (s) Pendentes de Ativação</small>
                    </a>
                </li>
                <li role="presentation" v-if="voluntarioPendente" @click="redirectVoluntario">
                    <a role="menuitem" target="_self" href="#" class="dropdown-item"><i class="icon-user-follow text-success"></i>
                        <small class="text-muted">{{voluntarioPendente}} Voluntário (s) Pendentes de Ativação</small>
                    </a>
                </li>
                <li v-for="not in notificacoesAvaliacao" :key="not.id" role="presentation">
                    <a role="menuitem" target="_self" href="#" class="dropdown-item"><i class="icon-user-follow text-success"></i>
                        <span v-if="not.notificacao.length > 10">
                            <small v-b-tooltip.hover :title="not.notificacao" class="text-muted">{{not.notificacao.substring(0, 48)}}...</small>
                        </span>
                        <span v-else>
                            <small v-b-tooltip.hover :title="not.notificacao" class="text-muted">{{not.notificacao}}</small>
                        </span>
                    </a>
                </li>
            </div>
            </ul>
    </template>
  </AppHeaderDropdown>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import SessionStorage from '@/services/session-storage'

export default {
  name: 'DefaultHeaderDropdownNotif',
  components: {
    AppHeaderDropdown
  },
  created () {
    this.$store.dispatch('buscarNotificacoes')
  },
  data: () => {
    return {
      itemsCount: 0,
      gestorPendente: 0,
      tutorPendente: 0,
      voluntarioPendente: 0,
      beneficiarioPendente: 0,
    }
  },
  computed: {
    notificacoes () {
      return this.$store.state.notificacao.listaNotificacoes
    },
    notificacoesAvaliacao () {
      return this.$store.state.usuario.notificacoes
    }
  },
  watch: {
    'notificacoes': function () {
      if (this.notificacoes) {
        for (let i = 0; i < this.notificacoes.length; i++) {
          let quantidadeUsuariosPendentes = this.notificacoes[i].quantidade_usuario_pendente
          let tiposUsuariosPendentes = this.notificacoes[i].tipo_usuario_pendente

          for (let j = 0; j < tiposUsuariosPendentes.length; j++) {
            if (tiposUsuariosPendentes[j] === 'P') {
              this.gestorPendente = quantidadeUsuariosPendentes[j]
            }

            if (tiposUsuariosPendentes[j] === 'L') {
              this.tutorPendente = quantidadeUsuariosPendentes[j]
            }

            if (tiposUsuariosPendentes[j] === 'V') {
              this.voluntarioPendente = quantidadeUsuariosPendentes[j]
            }

            if (tiposUsuariosPendentes[j] === 'B') {
              this.beneficiarioPendente = quantidadeUsuariosPendentes[j]
            }
          }
        }

        this.itemsCount = this.gestorPendente + this.tutorPendente + this.voluntarioPendente + this.beneficiarioPendente
      }
    }
  },
  methods: {
    redirectVoluntario: function () {
      let perfil = SessionStorage.get('tipoPerfil').replace(/['"]+/g, '')
      if (perfil === 'L') {
        this.$router.push('/usuarios-voluntarios')
      }

      if (perfil === 'P') {
        this.$router.push('/validar-usuarios-gestor')
      }
    },
    redirectBeneficiario: function () {
      let perfil = SessionStorage.get('tipoPerfil').replace(/['"]+/g, '')
      if (perfil === 'L') {
        this.$router.push('/validar-usuarios-tutor')
      }

      if (perfil === 'P') {
        this.$router.push('/validar-usuarios-gestor')
      }
    },
    redirectTutorInstrutor: function () {
      let perfil = SessionStorage.get('tipoPerfil').replace(/['"]+/g, '')
      if (perfil === 'P') {
        this.$router.push('/validar-usuarios-gestor')
      }
      if (perfil === 'A') {
        this.$router.push('/usuarios')
      }
    },
    redirectGestor: function () {
      let perfil = SessionStorage.get('tipoPerfil').replace(/['"]+/g, '')
      if (perfil === 'A') {
        this.$router.push('/usuarios')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/containers/DefaultHeaderDropdownNotif.vue